import React, {useEffect, useState} from "react";
import {useFetching} from "hooks/useFetching";
import {ApiServices} from "API";
import {AddressType, IAddress, INominee, NomineeIdType, NonceType, TokenType} from "API/types";
import ModalButton, {ModalVariant} from "components/UI/Modal/ModalButton";
import ModalHowToBuy from "./UI/Modal/ModalHowToBuy";
import {useProvider} from "hooks/useProvider";
import {ethers} from "ethers";
import abi from "ABI/index.json"
import NomineesList from "components/UI/NomineesList";
import Loader from "components/UI/Loader";

declare global {
    interface Window {
        ethereum?: any;
    }
}

const Vote: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [modalVariant, setModalVariant] = useState<ModalVariant>("" as ModalVariant);

    const [isModalHowToBuyOpen, setIsModalHowToBuyOpen] = useState<boolean>(false);

    const [address, setAddress] = useState<AddressType>("");
    const [token, setToken] = useState<TokenType>("");

    const [nominees, setNominees] = useState<INominee[]>([]);
    const [nomineesIsLoading, setNomineesIsLoading] = useState<boolean>(false);

    const addressNFT = "0x6073dcDf72679b2610D531d0e23413467A0e6FA4";
    const CHAIN_ID = "0x1";
    const contractNFTABI = abi;

    const provider = useProvider(window.ethereum);

    const getNominees = useFetching(async ([address]) => {
        const response = await ApiServices.getNominees(address);
        setNominees(response.data);
    }, setNomineesIsLoading);

    const makeVote = async (id: NomineeIdType) => {
        try {
            if (!provider) {
                setIsModalOpen(true);
                setModalVariant("installMetamask");
                return;
            }

            if (!address) {
                return;
            }

            if (provider.chainId !== CHAIN_ID) {
                await changeNetwork()
            }

            const currentProvider = new ethers.providers.Web3Provider(provider);
            const signer = currentProvider.getSigner();
            const contract = new ethers.Contract(addressNFT, contractNFTABI, signer);

            // tested account with nft 0x8D2413447FF297d30BdC475F6D5cb00254685aae
            const NFTs = await contract.balanceOf(address);

            if (+NFTs === 0) {
                setIsModalOpen(true);
                setModalVariant("noNFTs");
                return;
            }

            let tokenAuth: TokenType = token;

            if (!token) {
                const responseNonce = await ApiServices.getNonce(address);

                const signature = await getSignature(responseNonce.data);

                const responseLogin = await ApiServices.login(address, signature);
                setToken(responseLogin.data.token);
                localStorage.setItem("token", responseLogin.data.token);
                tokenAuth = responseLogin.data.token;
            }

            await ApiServices.vote(id, tokenAuth);
            return true;
        } catch (error) {
            console.log(error);
        }
    };

    const getSignature = async (nonce: NonceType) => {
        const currentProvider = new ethers.providers.Web3Provider(provider);
        const signer = currentProvider.getSigner();
        return await signer.signMessage(nonce);
    };

    const isWalletInstalled = async () => {
        try {
            if (!provider) {
                return;
            }

            const accounts = await provider.request({method: "eth_accounts"});

            if (accounts.length !== 0) {
                setAddress(accounts[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const changeNetwork = async () => {
        try {
            await provider.request({
                method: "wallet_switchEthereumChain",
                params: [{
                    chainId: CHAIN_ID
                }]
            });
        } catch (error) {
            console.log(error);
        }
    };

    const openModalHowToBuy = () => {
        console.log('asdf')
        setIsModalHowToBuyOpen(true)
    }

    const connectWallet = async () => {
        try {
            if (!provider) {
                setIsModalOpen(true);
                setModalVariant("installMetamask");
                return;
            }

            const accounts: AddressType[] = await provider.request({method: "eth_requestAccounts"});
            const address: AddressType = accounts[0];
            setAddress(address);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        isWalletInstalled();
    }, []);

    useEffect(() => {
        if (address && token) {
            getNominees(address);
        } else {
            getNominees("");
        }
    }, [address, token])

    useEffect(() => {
        const localToken = localStorage.getItem("token");

        if (localToken) {
            setToken(localToken);
        }
    }, []);

    useEffect(() => {
        if (!provider) {
            return () => provider.off('accountsChanged', changeAddress);
        }

        const changeAddress = (accounts: AddressType[]) => {
            const address = accounts[0];
            setAddress(address ? address : "");
        };

        provider.on('accountsChanged', changeAddress);
    }, [provider]);


    const [showResults, setShowResults] = useState<boolean>(false);

    const VotingStages = () => (
        <p className="vote__description h2">
                                <b className="disabled">Voting stage 1 (June 22 - June 29):</b><br />
                                <span className="disabled">Anyone may vote for their favorite Dancers and DJs by viewing, liking, commenting, and sharing on all social media via the below links provided. Every social media reaction is counted. The top 10 Dancers and top 4 DJ finalists are selected based on the total number of social media activity.</span><br /><br />
                                <b className="disabled">Voting stage 2 (June 29 - July 02):</b><br />
                                <span className="disabled">IggyBoy NFT holders vote for the top 10 Dancers and top 4 DJ finalists to rank the participants for the prize pool rewards and to determine Grand Prix finalists.</span> <br /><br />
                                <b className="disabled">Voting stage 3 (July 06 - July 11): </b><br />
                                <span className="disabled">The Grand Prix finalists have prepared a new dance video using the tracks of top 2 DJ finalists. Anyone may vote for the Grand Prix winner by viewing, liking, commenting, and sharing on all social media.</span><br /><br />
                            </p>
      )

    return (
        <>
            <section className="vote">
                <div className="vote__container">
                    <header className="vote__header">
                        <h2 className="h1 vote__title">
                        Final <span>Results!</span>
                        </h2>

                        <button
                                onClick={() => setShowResults(!showResults)}
                                className="button decor-text button--voting-stages">
                                Voting Stages
                            </button>

                        <div className="vote__info">
                            { showResults ? <VotingStages /> : null }
                            <div className="vote__description__buttons">
                            {/* <button
                                onClick={connectWallet}
                                className={`button vote__btn-wallet decor-text ${address ? "button--fulled" : ""}`}>
                                {address ? "Connected" : "Connect Wallet"}
                            </button> */}
                            {/* <button
                                onClick={openModalHowToBuy}
                                className="button decor-text">
                                How to Buy an Iggy to Vote?
                            </button> */}
                            </div>
                            
                        </div>
                    </header>

                    {
                        !nomineesIsLoading ? <NomineesList makeVote={makeVote} connectWallet={connectWallet} nominees={nominees}/> : <Loader/>
                    }
                </div>

                <span className="circle-effect-2" aria-label="circle effect"/>
                <span className="circle-effect-4" aria-label="circle effect"/>
                <span className="circle-effect-6" aria-label="circle effect"/>
            </section>

            <ModalButton variant={modalVariant} isOpen={isModalOpen} setIsOpen={setIsModalOpen}/>
            <ModalHowToBuy isOpen={isModalHowToBuyOpen} setIsOpen={setIsModalHowToBuyOpen}/>
        </>
    );
};

export default Vote;


